import { render, staticRenderFns } from "./fleeingOrderCount.vue?vue&type=template&id=5617b122&"
import script from "./fleeingOrderCount.vue?vue&type=script&lang=js&"
export * from "./fleeingOrderCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports